const setErrorsAsStringOrObject = (errors: any) =>
  Object.keys(errors).map((key) => ({ key, value: getStringOrStringInArray(errors[key]) }));

const removeArrayBrackets = (stringValue: string) =>
  stringValue.replace(new RegExp('\\[', 'g'), '.').replace(new RegExp('\\]', 'g'), '');

const getStringOrStringInArray = (error: any) => {
  if (Array.isArray(error)) {
    return error[0];
  } else {
    return error;
  }
};

const mapErrorResponseToArray = (errors: any) => {
  let count = 0;
  let loopLimit = false;
  let data: any = setErrorsAsStringOrObject(errors);
  const isEveryElementAString = (errors: any) => errors.every(({ value }: any) => typeof value === 'string');
  while (!isEveryElementAString(data) && !loopLimit) {
    count = count + 1;
    if (count > 25) loopLimit = true;
    const newData = data.map((el: any) =>
      !Array.isArray(el.value) && typeof el.value === 'object'
        ? Object.keys(el.value).map((key) => ({ key: el.key + ' : ' + key, value: el.value[key] }))
        : { key: el.key, value: getStringOrStringInArray(el.value) },
    );
    data = newData.flat(Infinity);
  }
  return data;
};

const createArrayOfPercentageOptions = (minNumber: number = 0, maxNumber: number = 100) => {
  return Array(maxNumber)
    .fill('')
    .map((el, index) => ({ option: `${index}%`, value: index }))
    .slice(minNumber);
};

export { mapErrorResponseToArray, removeArrayBrackets, createArrayOfPercentageOptions };
